import { gql } from '@apollo/client';

import { CORE_ESG_VALUE_FIELDS } from '../fragments/esgValue';

export const UPDATE_ESG_VALUES_BY_OVERVIEW_ID = gql`
  ${CORE_ESG_VALUE_FIELDS}
  mutation UpdateEsgValues($input: UpdateEsgValuesInput!) {
    updateEsgValues(input: $input) {
      created {
        ...CoreEsgValueFields
      }
      updated {
        ...CoreEsgValueFields
      }
      removed {
        id
      }
    }
  }
`;

export const CLEAN_UNLINKED_REQUESTED_ESG_VALUES = gql`
  mutation CleanUnlinkedRequestedESGValue($companyId: ID!) {
    cleanUnlinkedRequestedESGValue(companyId: $companyId)
  }
`;

export const UPDATE_SEMI_NARRATIVE_ENTRY_QUESTION_KPI_ESG_VALUES = gql`
  ${CORE_ESG_VALUE_FIELDS}
  mutation UpdateSemiNarrativeEntryQuestionEsgValues(
    $input: UpdateSemiNarrativeEntryQuestionEsgValuesInput!
  ) {
    updateSemiNarrativeEntryQuestionEsgValues(input: $input) {
      ... on UpdateSemiNarrativeEntryQuestionEsgValuesOutput {
        updated {
          ...CoreEsgValueFields
        }
      }
      ... on UpdateSemiNarrativeEntryQuestionDependentEsgValuesOutput {
        totalDependentKpisCount
      }
    }
  }
`;

export const MERGE_ESG_KPI_VALUES = gql`
  mutation MergeKpis {
    mergeKpis
  }
`;
